// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"562":"0e25bf51","790":"7c2b7d2e"}[chunkId] + ".chunk.js";
};